export const testimonials = [
  {
    quote:
      'Thank you! I saw excellence in this conference and I was wowed. Thank you for the intentionality, for the careful selection of speakers and for giving us an amazing experience. Well done!',
    name: 'Juliana Edem',
    role: 'Student, Accelerate 3.0',
    rating: 5,
  },
  {
    quote:
      'I love everything Ignite Pro stands for. It’s a picture of possibilities that I truly believe is limitless. The conference enthusiast in me is thoroughly satisfied. This made my month.',
    name: 'Rosephnienaan Dickson',
    role: 'Student, Accelerate 3.0',
    rating: 5,
  },
  {
    quote:
      'Thank you for investing your time, effort and resources into organising this event. I left inspired, challenged and motivated to become a better version of myself. Keep up the amazing work.',
    name: 'Oluebube Ezeabasili',
    role: 'Graduate, Accelerate 3.0',
    rating: 5,
  },
  {
    quote:
      'For Uri, winning the Ignite Pro Competition in Port Harcourt and receiving the grant came at the perfect time. The support has helped us strengthen our product, onboard new clients, and accelerate growth. Beyond funding, the competition also opened doors to valuable introductions and new client opportunities. We’re truly grateful for this boost and the belief in our vision.',
    name: ' ',
    role: 'Uri Creative',
  },
  {
    quote:
      'The Ignite Pro grant has really helped us at Straqa. We’re passionate about building tools that support SMEs and businesses to grow, and this support gave us the push we needed to move faster and reach more people.',
    name: ' ',
    role: 'Straqa',
  },
  {
    quote:
      'Ignite Pro is doing a great job as a community for young professionals and entrepreneurs, Accelerate 2.0 was an exciting experience, filled with impactful sessions. A lot was revealed by the speakers, we also got financial support from the pitching event, which enabled push our product development to another level. Ignite Pro is a community I recommend for aspiring entrepreneurs and leaders.',
    name: ' ',
    role: 'Green Paragon Limited',
  },
  {
    quote:
      'I am deeply grateful to IGNITE Pro Community for the life-changing grant that enabled me to pursue my trading career. Their support was instrumental in my success, and I am thankful for the opportunity. Their investment in me has paid off, and I am proud to be a testament to their impactful work .Thanks Team!',
    name: ' ',
    role: 'William Michael',
  },

  {
    quote:
      'With a deep gratitude and a heart felt appreciation to IGNITE PRO COMMUNITY for the life- changing business grant opportunity. Winning the grant was more than just a financial boost; it was a powerful vote of confidence in my vision, Business and potential. It was just a grant to the others, but  to me, it was a "transformative impact". Today,Mamachigos Beauty Touch is a step ahead, new skills has being added, new working equipment bought, more customers has been served and  lots more. Thank you!!! once more IGNITE pro community, your investment and impact in me is an unforgettable one!!.Thank you Team!!😊',
    name: ' ',
    role: 'Osuagwu chigozirim Basillia',
  },
  {
    quote:
      'Reflecting on the events of that day, particularly  as an awardee for-the business grant, I would say it was truly remarkable and inspiring. It was a sign that our mission was relevant to current realities and that our story was being heard. In a world where social enterprises and nonprofits are expected to do more with limited resources, Ignite Pro Community displayed a firm belief that its time to shift the narrative and focus on what truly matters, and that is none other than changing lives.',
    name: ' ',
    role: 'Confidence Jonathan Nwosu Founder, RAJ Foundation',
  },
  {
    quote:
      'Receiving the data analytics scholarship from Beylearning has been a truly life-changing opportunity. The program equipped me with practical, in-demand skills in data analysis, visualization, and critical thinking. I want to express my deepest gratitude to the instructors, whose expertise, patience, and support made complex concepts accessible and engaging. Their guidance played a key role in my growth and confidence in the field. I’m especially thankful to Beylearning for investing in me and creating an inclusive platform that bridges the gap between education and opportunity. As someone navigating the entry level of the analytics field, this experience has provided a strong foundation and a clearer sense of direction.',
    name: '',
    role: ' ',
  },
  {
    quote:
      'I am grateful to IGNITE Pro Community for opening the door to the Data Analytics Scholarship through their incredible network. With their support, I’ve built a strong foundation in data skills and gained clarity on my career direction. Their belief in learners like me has been both motivating and empowering. It truly gladdens my heart to be part of a community that invests in growth and potential.Thank you, IGNITE Pro Team!',
    name: '.',
    role: 'Diseph Mogbolu',
  },
];
